var _path, _path2, _path3, _g, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 21.5V65C64.5 68.315 61.815 71 58.5 71H13.5C13.5 71 7.5 71 7.5 65V8C7.5 4.685 10.185 2 13.5 2H45V15.5C45 18.815 47.685 21.5 51 21.5H64.5Z",
    fill: "#EFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 21.5H51C47.685 21.5 45 18.815 45 15.5V2L64.5 21.5Z",
    fill: "#D0E2FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.479 40.3495H18.5741C19.0147 42.0496 20.5321 43.3148 22.3531 43.3148C24.174 43.3148 25.6915 42.0496 26.1321 40.3495H34.2383C34.6789 42.0496 36.1963 43.3148 38.0173 43.3148C39.8382 43.3148 41.3557 42.0496 41.7963 40.3495H43.8914C44.4298 40.3495 44.8704 39.9047 44.8704 39.3611V35.4074C44.8704 33.7765 43.5487 32.4421 41.9333 32.4421H39.4662L35.8439 27.8756C35.6579 27.6384 35.374 27.5 35.0802 27.5H25.2901C24.9964 27.5 24.7125 27.6384 24.5265 27.8756L20.9041 32.4421H18.437C16.8217 32.4421 15.5 33.7765 15.5 35.4074V39.3611C15.5 39.9047 15.9406 40.3495 16.479 40.3495ZM22.3531 41.338C21.2762 41.338 20.3951 40.4484 20.3951 39.3611C20.3951 38.2738 21.2762 37.3843 22.3531 37.3843C23.43 37.3843 24.3111 38.2738 24.3111 39.3611C24.3111 40.4484 23.43 41.338 22.3531 41.338ZM38.0173 41.338C36.9404 41.338 36.0593 40.4484 36.0593 39.3611C36.0593 38.2738 36.9404 37.3843 38.0173 37.3843C39.0942 37.3843 39.9753 38.2738 39.9753 39.3611C39.9753 40.4484 39.0942 41.338 38.0173 41.338ZM36.96 32.4421H32.1432V29.4769H34.6103L36.96 32.4421ZM25.76 29.4769H26.2691V32.4421H23.4104L25.76 29.4769ZM17.458 35.4074C17.458 34.8638 17.8986 34.419 18.437 34.419H27.2481C27.7866 34.419 28.2272 33.9742 28.2272 33.4306V29.4769H30.1852V33.4306C30.1852 33.9742 30.6257 34.419 31.1642 34.419H41.9333C42.4718 34.419 42.9123 34.8638 42.9123 35.4074V38.3727H41.7963C41.3557 36.6726 39.8382 35.4074 38.0173 35.4074C36.1963 35.4074 34.6789 36.6726 34.2383 38.3727H26.1321C25.6915 36.6726 24.174 35.4074 22.3531 35.4074C20.5321 35.4074 19.0147 36.6726 18.5741 38.3727H17.458V35.4074Z",
    fill: "#7100DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29454_787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4424 29.8294C54.4424 29.1667 53.9051 28.6294 53.2424 28.6294H48.3293C47.6665 28.6294 47.1293 29.1667 47.1293 29.8294V30.1403C47.1293 30.8031 47.6665 31.3403 48.3293 31.3403H53.2424C53.9051 31.3403 54.4424 30.8031 54.4424 30.1403V29.8294Z",
    fill: "#A45CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4424 40.6741C54.4424 40.0114 53.9051 39.4741 53.2424 39.4741H48.3293C47.6665 39.4741 47.1293 40.0114 47.1293 40.6741V40.9851C47.1293 41.6478 47.6665 42.1851 48.3293 42.1851H53.2424C53.9051 42.1851 54.4424 41.6478 54.4424 40.9851V40.6741Z",
    fill: "#A45CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2959 35.2513C57.2959 34.5885 56.7586 34.0513 56.0959 34.0513H51.7178C51.0551 34.0513 50.5178 34.5885 50.5178 35.2513V35.5622C50.5178 36.2249 51.0551 36.7622 51.7178 36.7622H56.0959C56.7586 36.7622 57.2959 36.2249 57.2959 35.5622V35.2513Z",
    fill: "#A45CE7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 50.0928,
    width: 40.6667,
    height: 2.25926,
    rx: 1,
    fill: "#59C4C2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 55.7407,
    width: 23.7222,
    height: 2.25926,
    rx: 1,
    fill: "#59C4C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29454_787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.1667,
    height: 13.5556,
    transform: "matrix(-1 0 0 1 57.2959 28.6294)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickReferral);
export default __webpack_public_path__ + "static/media/quick-referral.1dbe077ef861d71e7a57fdb8dffb0104.svg";
export { ForwardRef as ReactComponent };